import React, { useState, useEffect } from 'react'
import AddOrEditInstitutionCategory from '../AddOrEditInstitutionCategory/AddOrEditInstitutionCategory';
import "./CustomDatatableInstitutionCategory.css";
import { FaPencilAlt } from "react-icons/fa";
import { BiEdit } from "react-icons/bi"
import { MdDeleteForever } from "react-icons/md";
import Pagination from '../Pagination/Pagination';
import { toast } from 'react-toastify';
import { deleteCategoryInstitution, getInstitutionCategories } from '../../services/http';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import { reload } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';




const CustomDatatableInstitutionCategory = (props) => {

    const { columns, 
            data, 
            changePage, 
            pageCount, 
            pageNumber, 
            perPage,
            handleShowDeleteModal, 
            handleCloseDeleteModal } = props;
    const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);

  const [processOngoing, setProcessOngoing] = useState(false)


    const navigate = useNavigate();


    const handleYesClicked = async (category) => {
setProcessOngoing(true)
        const reqdata = await deleteCategoryInstitution(category, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status !== 404 && reqdata.response.status !== 500) {
                let errorMsg = reqdata.response?.data.error;
 
                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });

                let response = await getInstitutionCategories(states.userToken.access_token, pageNumber, "");

                let response_copy = response.data?.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    
                dispatch({
                    type: "SET",
                    key: "institutionCategoriesList",
                    payload: response_copy,
                });
            } else {
                //    Should redirect to an Error Page
                // console.log(reqdata.response?.data.error)
                let errorMsg = reqdata.response?.data.error;
 
                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
            }
        } else {
            let response = await getInstitutionCategories(states.userToken.access_token, pageNumber, "");

            let response_copy = response.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "institutionCategoriesList",
                payload: response_copy,
            });
            setProcessOngoing(false)

            toast.success("Catégorie d'institution supprimée avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });


        }
    }

    return (
        <div className="table-responsive ">
            <table className="table table-striped dataTable w-100">
                <thead className="">
                    <tr role={"row"}>
                        {columns && columns.map((item, index) =>
                            <th key={index+"wcdicc"} className="text-left pl-5">
                                {item.label}</th>
                        )}
                        <th className="text-center w-30">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length != 0 ? data?.map((item, index) =>
                        <tr key={index+"wcdicd"}>
                            <td className="text-left pl-5">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                            <td className="text-left pl-5">
                                {item.libelle}
                            </td>
                            <td className="">
                                <BiEdit onClick={() => navigate(`/institution-category/${item.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                                <MdDeleteForever onClick={() => handleShowDeleteModal(item.id)} title="Supprimer" style={{ fill: "red", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-delete-button ml-1" />
                            </td>
                            <DeleteConfirmation processOngoing={processOngoing} handleYesClicked={handleYesClicked}  title={` la catégorie ${item.libelle} ?`} id={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} />
                        </tr>
                    ) : <h1 className="ok"></h1>}
                </tbody>
            </table>
            <Pagination pageCount={pageCount} changePage={changePage} />
        </div>
    )
}

export default CustomDatatableInstitutionCategory